import { h } from 'preact';
import boss from './boss.jpg';

const StartPage = ({ onStart }) => {
  return h(
    'div',
    { className: 'container' },
    h('img', {
      src: boss,
      className: 'image',
      width: 512,
      height: 512
    }),
    h('p',
      { className: 'boss-message' },
      '諸君にはこれから簡単な適性試験を受けてもらう。合格ラインは80点だ。なお、合格ラインに到達しなかった場合は即刻解雇処分とさせてもらう。諸君の検討を祈る。'
    ),
    h(
      'button',
      { onClick: onStart, className: 'button' },
      '試験を開始する'
    )
  );
};
export default StartPage;



/** WEBPACK FOOTER **
 ** ./src/StartPage.js
 **/